import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { getWorstWear } from 'pages/MaintenancePage/helpers/getWorstWear';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { PUMP_SEAL_DUE_PERCENT, TEST_ID } from './constants';
import type { FunctionComponent, Props, ServiceEvent } from './types';

import styles from './styles.module.scss';

const ServiceUpcomingList: FunctionComponent<Props> = ({
    className = '',
    drone,
    serviceIntervals,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const pumpWear = getWorstWear({
        interval: serviceIntervals.pumpSealKit,
        units: drone.pumps
    });
    const isPumpDue = pumpWear.configured && pumpWear.percentage >= PUMP_SEAL_DUE_PERCENT;
    const upcoming: ServiceEvent = isPumpDue
        ? { isUpcoming: true, what: t.SERVICE_EVENT_PUMP_SEAL, when: t.SERVICE_WHEN_4D }
        : { isUpcoming: true, what: t.SERVICE_EVENT_100H_MOTOR, when: t.SERVICE_WHEN_100H };
    const events: ServiceEvent[] = [
        upcoming,
        { what: t.SERVICE_EVENT_PUMP_CALIBRATION, when: t.SERVICE_WHEN_12D },
        { what: t.SERVICE_EVENT_PROP_ROTATION, when: t.SERVICE_WHEN_21D },
        { what: t.SERVICE_EVENT_ESC_FIRMWARE, when: t.SERVICE_WHEN_44D },
        { what: t.SERVICE_EVENT_BATTERY_TEST, when: t.SERVICE_WHEN_68D }
    ];

    return (
        <VerticalContainer className={`${styles.serviceUpcomingList} ${className}`} testId={testId}>
            <Wrapper className={styles.heading}>{t.SERVICE_UPCOMING_HEADING}</Wrapper>

            <VerticalContainer className={styles.serviceTimeline}>
                {events.map(event => {
                    const upcomingClass = event.isUpcoming ? styles.isUpcoming : '';

                    return (
                        <VerticalContainer
                            className={`${styles.serviceEvent} ${upcomingClass}`}
                            key={`${event.when}-${event.what}`}>
                            <Wrapper className={styles.serviceWhen}>{event.when}</Wrapper>

                            <Wrapper className={styles.serviceWhat}>{event.what}</Wrapper>
                        </VerticalContainer>
                    );
                })}
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default ServiceUpcomingList;
